var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecondBaseAdaptiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 131,
    viewBox: "0 0 131 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "base"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse",
    filter: "url(#filter0_f_1877_18489)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.783,
    cy: 25.8255,
    rx: 25.783,
    ry: 25.8255,
    transform: "matrix(0.988258 0.152797 -0.12672 0.991939 43.5469 36)",
    fill: "#0367E7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2",
    filter: "url(#filter1_f_1877_18489)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.783,
    cy: 25.8255,
    rx: 25.783,
    ry: 25.8255,
    transform: "matrix(0.988258 0.152797 -0.12672 0.991939 43.5469 36)",
    fill: "#0367E7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M45.3839 64.4397L70.2146 68.2788C71.0231 68.4038 71.0242 68.404 71.1297 67.5875C71.2106 66.9549 71.2495 66.3109 71.3842 65.6903C71.5188 65.0696 71.2854 64.9088 70.7092 64.8221C65.3767 64.0182 60.0491 63.1861 54.7204 62.3622L45.8227 60.9865C47.7181 51.7175 56.8574 44.607 67.4778 46.2998C78.0484 47.9862 85.8124 58.1326 84.1643 69.1211C82.6075 79.5173 73.0657 86.6225 62.6567 85.1499C51.925 83.6311 44.8583 73.9338 45.3839 64.4397Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1877_18489",
    x: 0.762501,
    y: 0.332813,
    width: 129.983,
    height: 130.448,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.65,
    result: "effect1_foregroundBlur_1877_18489"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1877_18489",
    x: 0.762501,
    y: 0.332813,
    width: 129.983,
    height: 130.448,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.65,
    result: "effect1_foregroundBlur_1877_18489"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondBaseAdaptiveIcon);
export default __webpack_public_path__ + "static/media/SecondBaseAdaptiveIcon.86db1600bf103a4da63d656df9e6ac39.svg";
export { ForwardRef as ReactComponent };